<template>
  <div class="feedback">
    <feedback-container></feedback-container>
  </div>
</template>
<script>
import FeedbackContainer from '@/components/feedback/Container.vue'
export default {
  name: 'feedback',
  components: {
    FeedbackContainer
  }
}
</script>
<style lang="stylus">
.feedback
  height 100%
</style>
